import { useState, useMemo } from 'react';

import { ModelTable, Button, SubHeader } from '@component';
import { useServices } from '@services';

import { collection } from './constants';
import { Item } from './Item';

export const DentitionList = () => {
  const [item, setItem] = useState(null);
  const [updatedOn, setUpdatedOn] = useState(new Date());
  const { db } = useServices();

  const newItem = {
    name: '',
    code: '',
    description: '',
    category: '',
    categoryCypher: '',
    productUrl: '',
  };

  const columns = useMemo(
    () => [
      {
        Header: '2D Image',
        accessor: ({ productUrl }) => {
          if (!productUrl) return;
          return (
            <div className="flex justify-center">
              <img src={productUrl} alt="Visual representation" height="60" width="90" />
            </div>
          );
        },
      },
      { Header: 'Age', accessor: 'name' },
      { Header: 'Code', accessor: 'code' },
      { Header: 'Category', accessor: 'category' },
      { Header: 'Cypher', accessor: 'categoryCypher' },
    ],
    []
  );

  return (
    <>
      <SubHeader title="Database Management" seperatorTitle="Dentition" />
      <div className="bg-white p-4 m-4 rounded-md mx-4 items-center">
        <div className="flex justify-end">
          <Button onClick={() => setItem(newItem)}>Add New Dentition</Button>
        </div>
        <ModelTable
          model={{ name: 'Dentition' }}
          collection={collection}
          columns={columns}
          version={updatedOn}
          onViewRow={row => setItem({ ...newItem, ...row })}
          className="mt-4"
          defaultSortBy={[{ id: 'code' }]}
          query={() => db.collection(collection).orderBy('name')}
        />
        <Item item={item} close={() => setItem(null)} saved={() => setUpdatedOn(new Date())}></Item>
      </div>
    </>
  );
};
